<template>
  <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
    <div class="bg-white detail">
      <div v-if="access_editing" class="row">
        <div class="col-12">
          <p class="text-center text-danger">
            <b>{{ access_editing }}</b>
          </p>
        </div>
      </div>
      <div class="row">
        <div v-if="dataState.includes(frmData.status) && frmData.config.workflow_transition.length > 0"
          class="col-12 mb-1 d-flex flex-row">
          <b-button type="button" class="mr-1 font12" size="sm" variant="exit"
            @click="onExit(frmData.id)">Thoát</b-button>
          <b-button v-if="frmData.status != 5" type="button" class="mr-1 font12" size="sm" variant="trash"
            @click="onDestroy(frmData.id)">Xóa</b-button>
          <b-button v-print="'#printArticle'" class="mr-1 font12" variant="grays" size="sm"><feather-icon
              icon="PrinterIcon" /></b-button>
          <b-button type="button" class="mr-1 font12" size="sm" :to="{ name: 'article-edit', params: { id: frmData.id } }"
            variant="grays"><feather-icon icon="EditIcon" /> Sửa</b-button>
          <b-button v-for="(item, index) in workflow_transition" :key="index" v-if="!item.hide" type="button"
            :variant="item.style" class="mr-1" @click="updateArticle(frmData.id, item.target_state)"> {{ item.desc }}
          </b-button>
          <div v-if="allow_show_published" class="d-flex flex-row">
            <div class="pr-1" style="padding-top: 0.7rem;"> <b-form-checkbox v-model="frmData.is_timer"
                class="checkboxLabel" value="1"><b>Hẹn giờ xuất bản</b></b-form-checkbox></div>
            <div>
              <flat-pickr v-model="frmData.published_at" class="form-control" :disabled="!frmData.is_timer"
                :config="config_date" placeholder="hh:mm, dd-mm-yyyy" />
            </div>
          </div>
        </div>
        <div v-else class="col-12 mb-1 d-flex flex-row">
          <b-button v-print="'#printArticle'" class="mr-1 font12" variant="grays" size="sm"><feather-icon
              icon="PrinterIcon" /></b-button>
        </div>
        <div v-if="frmData.status === 7" class="col-12 mb-1">
          <b-button type="button" class="mr-1 font12" size="sm" variant="green"
            @click="updateStatus('restore', frmData.id)">
            <feather-icon icon="RotateCcwIcon" /> Khôi phục </b-button>
          <b-button type="button" class="mr-1 font12" size="sm" variant="red" @click="updateStatus('delete', frmData.id)">
            <feather-icon icon="TrashIcon" /> Xóa hẳn </b-button>
        </div>
        <div id="printArticle" class="col-12">
          <h1 v-if="frmData.title_news"> {{ frmData.title_news }} </h1>
          <h1 v-else> {{ frmData.title }} </h1>
          <div v-if="category_name" class="head d-flex flex-row justify-content-between">
            <div class="d-flex flex-row" style="line-height: 2">
              <span><strong>{{ category_name }}</strong></span>
              <span class="pl-1 pr-1">|</span>
              <span><strong>{{ frmData.pseudonym }}</strong></span>
              <span class="pl-1 pr-1">|</span>
              <span>{{ datetime }} (GMT+7)</span>
            </div>
            <div class="d-flex flex-row" />
          </div>
          <div v-if="frmData.content_news" class="view" v-html="frmData.content_news" />
          <div v-else class="view" v-html="frmData.content" />
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import print from 'vue-print-nb'
import {
  BCard, BRow, BCol, BButton, BLink, BOverlay, BFormCheckbox, BFormGroup,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import store from '@/store'
import { showToast, useRouter } from '@core/utils/utils';
import useJwt from '@/auth/jwt/useJwt';
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BLink,
    BOverlay,
    BFormCheckbox,
    flatPickr,
    BFormGroup,
  },
  directives: {
    print,
  },
  props: {
    article_id: '',
    type_view: '',
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const dataUser = useJwt.getUser();
    const frmData = ref({})
    const dataState = ref([1, 2, 3, 4, 5, 6])
    const category_name = ref('');
    const datetime = ref('');
    const loading = ref('')
    const viewType = ref('');
    const access_editing = ref('')
    const allow_edit = ref(false)
    const workflow_transition = ref([])
    const allow_show_published = ref(false)

    if (props.article_id != undefined) {
      loading.value = true;

      if (props.type_view == 'show') {
        store.dispatch('article/show', { id: props.article_id })
          .then(response => {
            loading.value = false;
            const result = response.data;
            if (result.code == 200) {
              frmData.value = result.data;
              category_name.value = result.data.config.category_name;
              datetime.value = result.data.config.datetime;
            }
          })
      } else {
        store.dispatch('article/edit', { id: props.article_id })
          .then(response => {
            loading.value = false;
            const result = response.data;

            if (result.code == 200) {
              context.emit('updateList')
              frmData.value = result.data;
              category_name.value = result.data.config.category_name;
              datetime.value = result.data.config.datetime;
              workflow_transition.value = result.data.config.workflow_transition
              allow_edit.value = result.data.config.allow_edit
              allow_show_published.value = result.data.config.allow_show_published
              // console.log('workflow_transition')
            } else {
              access_editing.value = response.data.message;
            }
          })
      }
    }
    if (props.type_view != undefined) {
      viewType.value = props.type_view;
    }
    const config_date = ref({
      dateFormat: 'H:i, d-m-Y',
      wrap: true,
      enableTime: true,
      time_24hr: true,
      defaultHour: new Date().getHours(),
      defaultMinute: new Date().getMinutes(),
      locale: Vietnamese, // locale for this instance only
    });
    return {
      dataUser,
      frmData,
      dataState,
      category_name,
      datetime,
      loading,
      access_editing,
      viewType,
      config_date,
      workflow_transition,
      allow_edit,
      allow_show_published,
    }
  },
  methods: {
    updateArticle(article_id, status) {
      this.frmData.status = status;
      this.loading = true
      // console.log('viewType', this.viewType)
      store.dispatch('article/update', { data: this.frmData, id: article_id })
        .then(response => {
          if (response.data.code == 200) {
            this.loading = false
            const result = response.data.data;
            showToast(response.data.message, { variant: 'success' })
            // console.log('view_type', this.viewType)
            if (this.viewType) {
              this.$emit('updateList', { type: true })
            } else if (result.url) {
              this.$router.push({ name: result.url });
            }
          } else if (response.data.errors) {
            this.$refs.articleForm.setErrors(responsed.data.errors);
          }
        })
    },
    onExit(id) {
      const params = { type: 'unlock', ids: { id } }
      store.dispatch('article/lock', params).then(response => {
        const result = response.data;
        if (result.code == 200) {
          if (this.viewType) {
            this.$emit('updateList', { type: true })
          } else {
            window.history.back();
          }
          showToast(result.message, { variant: 'success' })
        } else {
          showToast(result.message);
        }
      })
    },
    onDestroy(id) {
      this.$swal({
        title: '',
        text: 'Bạn có chắc chắn muốn xóa bài viết này không?',

        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.loading = true

          store.dispatch('article/destroy', { ids: [id], type: '' }).then(response => {
            const result = response.data;
            if (result.code == 200) {
              this.loading = false
              this.$emit('updateList', { type: true })
              showToast(result.message, { variant: 'success' })
            } else {
              showToast(result.message);
            }
          })
        }
      })
    },

    updateStatus(type, article_id) {
      const text_message = (type == 'restore') ? 'Bạn có chắc chắn muốn khôi phục bài viết này không?' : 'Bạn có chắc chắn muốn xóa hẳn bài viết này không?';
      this.$swal({
        title: '',
        text: text_message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          if (type == 'restore') {
            const id = article_id;
            store.dispatch('article/restore', { id })
              .then(response => {
                const result = response.data;
                if (result.code == 200) {
                  this.$emit('updateList', { type: true })
                  showToast(result.message, { variant: 'success' })
                } else {
                  showToast(result.message)
                }
              })
          } else {
            const params = {
              type: 'delete',
              ids: [article_id],
            }
            store.dispatch('article/destroy', params).then(response => {
              const result = response.data;
              if (result.code == 200) {
                this.$emit('updateList', { type: true })
                showToast(result.message, { variant: 'success' })
              } else {
                showToast(result.message);
              }
            })
          }
        }
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
